import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Message } from './styled';

export default function Modal({
  show, children, handleFunction, close,
}) {
  if (!show) return <> </>;
  return (
    <Message id="modal">
      <div>
        <h1>{children}</h1>
        <div>
          <button onClick={(e) => (handleFunction(e))} type="button">Sim</button>
          <button onClick={(e) => (close(e))} type="button">Não</button>
        </div>
      </div>
    </Message>
  );
}

Modal.defaultProps = {
  show: false,
};

Modal.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.string.isRequired,
  handleFunction: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};
